import { InventoryTypeKey } from '~/constants/inventoryType';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import { getVehicleDetailsForNative } from '~/selectors';
import createSelector from '~/store/createSelector';

export const getEventPayload = createSelector(
  getVehicleDetailsForNative,
  ({
    inventoryType = InventoryTypeKey.Core,
    make = '',
    model = '',
    stockNumber = 0,
    trim = '',
    vehicleId = 0,
    vehicleImage,
    year = 0
  }): PurchaseEventPayload => ({
    inventoryType,
    make,
    model,
    stockNumber,
    trim,
    vehicleId,
    vehicleImage,
    year
  })
);
